export type ColorScheme = 'light' | 'dark'

const DARK_QUERY = '(prefers-color-scheme: dark)'

/**
 * Mirrors the OS colour scheme onto `<html class="dark">` so the `.dark` token
 * register (packages/shared-ui tokens.css) and Tailwind's `dark:` variants
 * follow it, so the app matches the device without a setting of its own.
 */
const applyColorScheme = (root: HTMLElement, scheme: ColorScheme): void => {
  root.classList.toggle('dark', scheme === 'dark')
  root.style.colorScheme = scheme
}

export const followSystemColorScheme = (
  root: HTMLElement = document.documentElement,
  query: MediaQueryList = window.matchMedia(DARK_QUERY)
): (() => void) => {
  const sync = () => applyColorScheme(root, query.matches ? 'dark' : 'light')
  sync()
  query.addEventListener('change', sync)
  return () => query.removeEventListener('change', sync)
}
